import RulesPage from "./pages/rules/rules";
import MonitoringQueuePage from "./pages/monitoringQueue/MonitoringQueue";
import RuleEditor from "./pages/rules/ruleEditor/RuleEditor";
import SavedSearchViewPage from "./pages/advancedSearchHistory/SavedSearchView/SavedSearchViewPage";
import Settings from "./pages/settings/settings";
import ActivityLog from "./pages/activityLog/ActivityLog";
import { useTenancy } from "./redux/features/permissions/permissionsSlice";
import { useCheckPermission } from "./hooks/useCheckPermission";
import Home from "./pages/home/home";
import AdvancedSearchPage from "./pages/advancedSearch/AdvancedSearchPage";
import SingleReports from "./pages/reports/singleReport/singleReport";
import MultipleReport from "./pages/reports/multipleReport/multipleReport";
import DailyForOverlimit from "./pages/reports/dailyForOverlimit/dailyForOverlimit";
import ForMonitoring from "./pages/reports/forMonitoring/forMonitoring";
import AdvancedSearchHistory from "./pages/advancedSearchHistory/AdvancedSearchHistoryPage";
import FlagsDetailsAdvancedSearch from "./pages/reports/CustomReports/FlagsDetailsAdvancedSearch/FlagsDetailsAdvancedSearch";
import FlagDetails from "./pages/flagDetails/FlagDetails";
import CustomReports from "./pages/reports/CustomReports/CustomReports";
import FlagsAdvancedSearch from "./pages/reports/CustomReports/FlagsAdvancedSearch/FlagsAdvancedSearch";
import AuditTrail from "./pages/auditTrail/AuditTrail";
import ManualSearch from "./pages/manualSearch/ManualSearch";

export default function useGetRoutes() {
  const tenancy = useTenancy();
  const hasReportsPermission = useCheckPermission("REVIEW_REPORTS");
  const hasAuditTrailPermission = useCheckPermission("REVIEW_AUDIT");
  const hasLogsPermission = useCheckPermission("LOGS");
  const hasMonitoringPermission = useCheckPermission(
    tenancy === "SINGLE" ? "REVIEW_MONITORING" : "SEARCH_REVIEW_MONITORING",
  );
  const hasManualSearchPermission = useCheckPermission(
    tenancy === "SINGLE" ? "MANUAL_SEARCH" : "MANUAL_SEARCH_MULTI",
  );

  return [
    { path: "/", element: <Home /> },
    { path: "/rules", element: <RulesPage /> },
    { path: "rules/rule-dashboard/:id", element: <RuleEditor /> },
    {
      path: "/advanced-search-history/rule-dashboard/:id",
      element: <SavedSearchViewPage />,
    },
    {
      path: "/reports-custom/flags-advanced-search/:id",
      element: <FlagsAdvancedSearch />,
    },
    ...(hasMonitoringPermission
      ? [
          { path: "/monitoring", element: <MonitoringQueuePage /> },
          { path: "/monitoring/flag-details/:id", element: <FlagDetails /> },
          {
            path: "/reports-for-monitoring/flag-details/:id",
            element: <FlagDetails />,
          },
          {
            path: "/reports-custom/flag-details-advanced-search/:id",
            element: <FlagsDetailsAdvancedSearch />,
          },
        ]
      : []),
    ...(hasReportsPermission
      ? [
          { path: "/reports-single/*", element: <SingleReports /> },
          { path: "/reports-multiple/*", element: <MultipleReport /> },
          { path: "/reports-daily-overlimit/*", element: <DailyForOverlimit /> },
          { path: "/reports-for-monitoring/*", element: <ForMonitoring /> },
          { path: "/reports-custom/*", element: <CustomReports /> },
        ]
      : []),
    ...(hasAuditTrailPermission
      ? [{ path: "/audit-trail", element: <AuditTrail /> }]
      : []),
    ...(hasLogsPermission
      ? [{ path: "/activity-log", element: <ActivityLog /> }]
      : []),
    ...(hasManualSearchPermission
      ? [
          { path: "/manual-search", element: <ManualSearch /> },
          { path: "/advanced-search", element: <AdvancedSearchPage /> },
          { path: "/advanced-search-history", element: <AdvancedSearchHistory /> },
        ]
      : []),
    { path: "/settings", element: <Settings /> },
  ];
}
